import React, { memo, Fragment } from "react";
import { useParams } from "react-router-dom";
import SidebarMenu from "../../../../../../../components/partials/components/sidebar/sidebar-menu";
import { findIcon } from "../../../../../../dashboard/icons";

const Ecommercevarticalnav = memo(() => {
  const { channel_id } = useParams();
  return (
    <Fragment>
      <ul className="sub-nav">
        <SidebarMenu
          isTag={"true"}
          staticIcon="false"
          pathname={"/channel/dashboard/" + channel_id}
          title="Dashboard"
          minititle={findIcon("Dashboard", "dual-tone", 20)}
        >
          <i className="icon">{findIcon("Dashboard", "dual-tone", 20)}</i>
        </SidebarMenu>
        <SidebarMenu
          isTag={"true"}
          staticIcon="false"
          pathname={"/channel/videos/" + channel_id}
          title="Videos"
          minititle={findIcon("Video", "dual-tone", 20)}
        >
          <i className="icon">{findIcon("Video", "dual-tone", 20)}</i>
        </SidebarMenu>
        <SidebarMenu
          isTag="true"
          staticIcon="false"
          pathname={"/channel/analytics/" + channel_id}
          title="Analytics"
          minititle={findIcon("Analytics", "dual-tone", 20)}
        >
          <i className="icon">{findIcon("Analytics", "dual-tone", 20)}</i>
        </SidebarMenu>
        <SidebarMenu
          isTag="true"
          staticIcon="false"
          pathname={"/channel/comments/" + channel_id}
          title="Comments"
          minititle={findIcon("Comment-notification", "dual-tone", 20)}
        >
          <i className="icon">
            {findIcon("Comment-notification", "dual-tone", 20)}
          </i>
        </SidebarMenu>
        <SidebarMenu
          isTag="true"
          staticIcon="false"
          pathname={"/channel/campaign/" + channel_id}
          title="Campaign"
          minititle={findIcon("Campaign", "dual-tone", 20)}
        >
          <i className="icon">{findIcon("Campaign", "dual-tone", 20)}</i>
        </SidebarMenu>
        <SidebarMenu
          isTag="true"
          staticIcon="false"
          pathname={"/channel/customization/" + channel_id}
          title="Customization"
          minititle={findIcon("Tools", "dual-tone", 20)}
        >
          <i className="icon">{findIcon("Tools", "dual-tone", 20)}</i>
        </SidebarMenu>
      </ul>
    </Fragment>
  );
});
Ecommercevarticalnav.displayName = "Ecommercevarticalnav";
export default Ecommercevarticalnav;
